const state = {
	total: 0,
	sessions: null
}

export default state
